import { AppStoreBtn, PlayStoreBtn } from '@components/Buttons';
import { mc } from '@styles';
import { StaticImage } from 'gatsby-plugin-image';
import React, { FC } from 'react';

interface Props {
  className?: string;
  title?: string;
  layout?: 'vertical' | 'horizontal';
}

export const AppDownloadQR: FC<Props> = ({ className, title, layout = 'horizontal' }) => {
  if (layout === 'vertical')
    return (
      <div
        className={`p-2 p-3 xl:p-6 rounded-lg border flex flex-col ${className}`}
        style={{ borderColor: 'rgba(0, 0, 0, 0.2)' }}
      >
        {!!title && <span className="block text-lg font-bold mb-2">{title}</span>}
        <div className="flex flex-row items-center md:border-b pb-4 mb-5" style={{ borderBottomColor: 'rgba(0, 0, 0, 0.2)' }}>
          <StaticImage
            className="mr-6"
            height={128}
            src="./assets/qr.png"
            alt="Scan the QR code to download the app on your phone"
          />
          <p className="font-medium text-ocean-blue w-36">Scan the QR code to download the app on your phone</p>
        </div>

        <div className="flex flex-col md:flex-row items-center mt-6 md:mt-0">
          <AppStoreBtn className="mb-2 lg:mb-0 lg:mr-2" />
          <PlayStoreBtn />
        </div>
      </div>
    );

  return (
    <div
      className={mc(
        `p-2 p-3 xl:p-6`,
        'rounded-lg md:border',
        'flex md:inline-flex flex-col md:flex-row items-center justify-center md:justify-start',
        className,
      )}
      style={{ borderColor: 'rgba(0, 0, 0, 0.2)' }}
    >
      <div
        className="flex flex-row items-center md:border-r mr-3 lg:pr-8 lg:mr-8 xl:mr-0 hidden lg:flex"
        style={{ borderRightColor: 'rgba(0, 0, 0, 0.2)' }}
      >
        <StaticImage
          className="mr-6"
          height={128}
          width={128}
          layout="fixed"
          src="./assets/qr.png"
          alt="Scan the QR code to download the app on your phone"
        />
        <p className="font-medium text-ocean-blue text-sm lg:text-md w-36">Scan the QR code to download the app on your phone</p>
      </div>

      <div className="flex flex-row lg:flex-col xl:flex-row items-center mt-6 md:mt-0">
        <AppStoreBtn className="md:ml-4 lg:ml-0 xl:ml-4 md:mr-2 lg:mr-0 xl:mr-2 lg:mb-2 xl:mb-0" />
        <PlayStoreBtn />
      </div>
    </div>
  );
};

export default AppDownloadQR;
